import { readAccessToken } from '@clara/auth'
// const ACCESS_TOKEN_KEY = "clara_session_access_token";

const storage = {
  getToken: () => {
    const token = readAccessToken()
    return token
  },
}

export default storage
